import { __assign } from "tslib";
import React from 'react';
import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import InternalMultiselect from './internal';
var Multiselect = React.forwardRef(function (props, ref) {
    var baseComponentProps = useBaseComponent('Multiselect');
    return React.createElement(InternalMultiselect, __assign({}, props, baseComponentProps, { ref: ref }));
});
applyDisplayName(Multiselect, 'Multiselect');
export default Multiselect;
//# sourceMappingURL=index.js.map